<span class="badge"
  [ngClass]="[
    'status-' + status?.id,
    isCaptioned && 'captioned',
  ]"
  [ngbTooltip]="tooltip">

  <span class="skeleton" *ngIf="status == null">
    •&ensp;•&ensp;•
  </span>

  <span class="status">{{status?.name}}</span>

  <charging-power-profile-badge
    *ngIf="profile != null"
    style="margin-right: -4px"
    [isCaptioned]="status.id == 3"
    [isColored]="status.id == 3"
    [profile]="profile">
  </charging-power-profile-badge>
</span>
